import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import "./header.scss"

const Header = ({ siteTitle }) => (
  <header>
    <div className="nav">
      <div className="navTitle">
        <h1>
          <Link
            to="/"
            className="titleLink"
          >
            {siteTitle}
          </Link>
        </h1>
      </div>
      <div className="navLinks">
        <ul>
          <Link activeClassName="current" to="/"><li>Home</li></Link>
          <Link activeClassName="current" to="/about/"><li>About Stop Toxic Housing</li></Link>
          <Link activeClassName="current" to="/site/"><li>The US Navy Toxic Waste Site</li></Link>
          <Link activeClassName="current" to="/proposal/"><li>Freeway Air Toxins</li></Link>
          <Link activeClassName="current" to="/contribute/"><li>Contribute</li></Link>
        </ul>
      </div>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
